import * as React from 'react';
import { Icon } from '@grandvisionhq/icons';

const iconMap = {
    wheelchairAccessible: 'wheelchair',
    hearingAppointmentPossible: 'hearing-test'
};
const StoreTileIcons = ({ icons , labels  })=>/*#__PURE__*/ React.createElement("div", {
        className: "store-tile__icons"
    }, icons.map((icon)=>/*#__PURE__*/ React.createElement(Icon, {
            name: iconMap[icon],
            key: icon,
            width: 20,
            height: 20,
            "aria-label": labels[icon]
        })
    ))
;
var StoreTileIconsComponent = StoreTileIcons;

export { StoreTileIconsComponent as default };
//# sourceMappingURL=StoreTileIcons.js.map
